export default __webpack_public_path__ + "static/media/hn-unten.85e8d578.jpg";